import * as React from 'react'
import Image from 'next/image'

import ImgixImage from 'components/ImgixImage/ImgixImage'

import placeholder from '../placeholder.jpeg'
import PlayButton from '../PlayButton'
import CardTag from './CardTag'
import DiscountBadge from './DiscountBadge'
import PriceExpressDeliveryTag from './PriceExpressDeliveryTag'
import ProfileSkeleton from './ProfileSkeleton'

import styles from './Profile.module.css'

type ProfileProps = {
  talentName: string
  talentDescription?: string
  imageUrl: string
  videoUrl?: string
  price?: string
  originalPrice?: string
  expressDelivery?: '1h' | '24h'
  tag?: string
  discountPercent?: string
  loading: boolean
}

const Profile: React.FC<ProfileProps> = ({
  talentName,
  talentDescription,
  imageUrl,
  videoUrl,
  price,
  originalPrice,
  expressDelivery,
  tag,
  discountPercent,
  loading,
}) => {
  if (loading) return <ProfileSkeleton />

  return (
    <>
      <div className={styles.profileMediaContainer}>
        {!videoUrl &&
          (imageUrl?.includes('imgix') ? (
            <ImgixImage
              className={styles.profileImage}
              src={imageUrl || placeholder}
              alt={talentName}
              layout="fill"
            />
          ) : (
            <Image
              className={styles.profileImage}
              src={imageUrl || placeholder}
              alt={talentName}
              layout="fill"
            />
          ))}
        {tag && <CardTag tag={tag} />}
        {discountPercent && <DiscountBadge discountPercent={discountPercent} />}
      </div>

      <div className={styles.profileContentContainer}>
        <div className={styles.priceTagPlayButtonContainer}>
          {price && (
            <PriceExpressDeliveryTag
              expressDelivery={expressDelivery}
              price={price}
              originalPrice={originalPrice}
            />
          )}
          {videoUrl && <PlayButton />}
        </div>
        <div className={styles.profileDetails}>
          <h3 className={styles.talentName}>{talentName}</h3>
          <p className={styles.talentDescription}>{talentDescription}</p>
        </div>
      </div>
    </>
  )
}

export default Profile
